export const WHATSAPP_URL = "https://wa.me/6282229554434";
export const MAPS_URL = "https://maps.app.goo.gl/VRYYDbsoPZzSsYfT7?g_st=iw";
export const EMAIL_URL = "mailto:utamajaya.n@gmail.com";
export const PROFILE_PDF_URL = "/assets/UJN-Company-Profile.pdf";

export const NAV_LINKS = [
  { label: "HOME", href: "#home", testId: "nav-link-home" },
  { label: "ABOUT", href: "#about", testId: "nav-link-about" },
  { label: "FACILITY", href: "#facility", testId: "nav-link-facility" },
  { label: "SOLUTIONS", href: "#solutions", testId: "nav-link-solutions" },
  { label: "PRODUCTS", href: "#products", testId: "nav-link-products" },
  { label: "LOCATION", href: "#location", testId: "nav-link-location" },
  { label: "CONTACT", href: "#contact", testId: "nav-link-contact" },
];
